<template>
  <div v-if="!isLoading && qaList.length > 0" class="recipe-qa-container mt-4">
    <h4 class="mb-3">Вопросы и ответы</h4>
    <div class="qa-list">
      <div v-for="(item, index) in qaList" :key="index" class="qa-item">
        <a
          href="#"
          class="qa-question"
          data-bs-toggle="collapse"
          :data-bs-target="'#collapse' + index"
          aria-expanded="false"
          :aria-controls="'collapse' + index"
          @click.prevent
        >
          {{ item.question }}
        </a>
        <div :id="'collapse' + index" class="collapse qa-answer">
          {{ item.answer }}
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="isLoading" class="text-center my-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Загрузка...</span>
    </div>
    <p class="mt-2 text-muted">Генерируем полезные советы по рецепту...</p>
  </div>
  <div v-else-if="error" class="alert alert-warning small mt-3">
    Не удалось загрузить вопросы и ответы: {{ error }}
  </div>
</template>

<script>
export default {
  name: "RecipeQA",
  props: {
    recipeId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      qaList: [],
      isLoading: false,
      error: null,
    };
  },
  methods: {
    async fetchQA() {
      if (!this.recipeId) return;
      this.isLoading = true;
      this.error = null;
      this.qaList = [];
      try {
        const rawResponse = await this.sendCmd(`recipe.getQA/${this.recipeId}`);
        const cleanJson = this.extractJSONFromMarkdown(rawResponse);
        this.qaList = JSON.parse(cleanJson);
      } catch (err) {
        console.error("Error fetching recipe Q&A:", err);
        this.error = err.message || "Неизвестная ошибка";
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Extracts a JSON string from a Markdown code block.
     * Handles cases where the AI wraps the JSON in ```json ... ```.
     * @param {string} markdownString The raw string from the AI.
     * @returns {string} The cleaned JSON string.
     */
    extractJSONFromMarkdown(markdownString) {
      const match = markdownString.match(/```json\s*([\s\S]*?)\s*```/);
      if (match && match[1]) {
        return match[1].trim();
      }
      return markdownString.trim(); // Return as is if no markdown block is found
    },
  },
  mounted() {
    this.fetchQA();
  },
  watch: {
    recipeId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchQA();
      }
    },
  },
};
</script>

<style scoped>
.recipe-qa-container {
  padding-top: 1rem;
  border-top: 1px solid var(--bs-border-color-translucent);
}

.qa-question {
  text-decoration: none;
  color: var(--bs-body-color);
  /* font-weight: 500; */
  display: block;
}

.qa-question:hover {
  color: var(--bs-success);
}

.qa-item {
  border: 1px solid var(--bs-border-color);
  /* background-color: var(--bs-tertiary-bg); */
  border-radius: 8px;
  padding: 0.75rem;
  margin-bottom: 1.2rem;
}

.qa-question::before {
  /* Bootstrap Icons: chevron-right */
  /* content: "\F285"; 
  font-family: "bootstrap-icons";
  margin-right: 0.5rem;
  transition: transform 0.2s ease-in-out;
  display: inline-block; */
}

.qa-question[aria-expanded="true"]::before {
  transform: rotate(90deg);
}

.qa-answer {
  color: var(--bs-secondary-color);
  padding-left: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
</style>
